export const titleWrongLogin = "Thông tin đăng nhập không chính xác!"
export const titleWarningChangeDevice = "Số lượng thiết bị đã thay đổi, vui lòng làm mới để cập nhật!"